import Vue from 'vue'
import Router from 'vue-router'
import guide from '@/components/guide/guide'
import openStore from '@/components/openStore/openStore'
import brandStore from '@/components/brandStore/brandStore'
import index from '@/components/index/index'
import chooseStore from '@/components/chooseStore/chooseStore'
import createStore from '@/components/createStore/createStore'
import getPassword from '@/components/getPassword/getPassword'
import login from '@/components/login/login'
import loginLi from '@/components/login-li/login'
import register from '@/components/register/register'
import agreement from '@/components/agreement/agreement'
import bindAccount from '@/components/bindAccount/bindAccount'
import toLoad from '@/components/toLoad/toLoad'
import crossIndex from '@/components/crossIndex/crossIndex'
import storeAuth from '@/components/storeAuth/storeAuth'
import activation from '@/components/activation/activation'
import updatePassword from '@/components/updatePassword/updatePassword'
import bindAliyun from '@/components/bindAliyun/bindAliyun'
import chainStoreActiveProcess from '@/components/chainStore/active-process'
import qingtingProcess from '@/components/qingting/active-process'

Vue.use(Router)
    
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/index.html',
      name: 'index',
      component: index
    },
    {
      path: '/agreement.html',
      name: 'agreement',
      component: agreement
    },
    {
      path: '/guide.html',
      name: 'guide',
      component: guide
    },
    {
      path: '/brandStore.html',
      name: 'brandStore',
      component: brandStore
    },
    {
      path: '/openStore.html',
      name: 'openStore',
      component: openStore
    },
    {
      path: '/updatePassword.html',
      name: 'updatePassword',
      component: updatePassword
    },

    {
      path: '/chooseStore.html',
      name: 'chooseStore',
      component: chooseStore
    },
    {
      path: '/createStore/:id.html',
      name: 'createStore',
      component: createStore
    },
    {
      path: '/getPassword.html',
      name: 'getPassword',
      component: getPassword
    },
    {
      path: '/login.html',
      name: 'login',
      component: login
    },
    {
      path: '/login-li.html',
      name: 'login-li',
      component: loginLi
    },
    {
      path: '/register.html',
      name: 'register',
      component: register
    },
    {
      path: '/bindQq.html',
      name: 'bindQq',
      component: bindAccount
    },
    {
      path: '/bindWx.html',
      name: 'bindWx',
      component: bindAccount
    },
    {
      path: '/toLoad.html',
      name: 'toLoad',
      component: toLoad
    },
    {
      path: '/crossIndex.html',
      name: 'crossIndex',
      component: crossIndex
    },
    {
      path: '/storeAuth.html',
      name: 'storeAuth',
      component: storeAuth
    },
    // 餐饮短信激活
    {
      path: '/activation/:id.html',
      name: 'activation',
      component: activation
    },
    // 阿里云市场跳转绑定
    {
      path: '/bindAliyun.html',
      name: 'bindAliyun',
      meta: {
        isLogin: false
      },
      component: bindAliyun
    },
    {
      path: '/chainStore/active-process.html',
      name: 'chainStoreActiveProcess',
      meta: {
        isLogin: false
      },
      component: chainStoreActiveProcess
    },
    {
      path: '/qingting/active-process.html',
      name: 'qingtingProcess',
      meta: {
        isLogin: false
      },
      component: qingtingProcess
    },
    {
      path: '/',
      redirect: '/login.html' // 重定向
    },
    {
      path: '**', // 错误路由
      redirect: '/login.html' // 重定向
    }
    // {
    //   path: '**',   // 错误路由
    //   redirect: '/index.html'   //重定向
    // }
  ]
})